import { oz } from '@weft/utils';
import { PeriodSchema } from '../../primitives/period-schema';

export const NewBillingSettingsSchema = oz.object({
  billingCycle: PeriodSchema.optional(),
}).openapi('NewBillingSettings');

export type NewBillingSettings = oz.infer<typeof NewBillingSettingsSchema>;